import React, { useState, useEffect } from "react";
import { string, func, shape } from "prop-types";
import Image from "pages/_components/Image";

export default function FilterTableHead({ columnFilter, filterName, changeFilter }) {
    const [ascendent, setAscendent] = useState(true);
    const [descendent, setDescendent] = useState(true);

    FilterTableHead.propTypes = {
        columnFilter: shape({}).isRequired,
        filterName: string.isRequired,
        changeFilter: func.isRequired,
    };

    const changeOrder = () => {
        if (ascendent && descendent) {
            setDescendent(false);
            changeFilter(filterName, "ascendent");
        } else if (ascendent && !descendent) {
            setDescendent(true);
            setAscendent(false);
            changeFilter(filterName, "descendent");
        } else if (!ascendent && descendent) {
            setDescendent(false);
            setAscendent(true);
            changeFilter(filterName, "ascendent");
        }
    };

    useEffect(() => {
        if (columnFilter.filterSelected === filterName) {
            if (columnFilter.directionFilter === "ascendent") {
                setDescendent(false);
            } else {
                setAscendent(false);
            }
        } else {
            setAscendent(true);
            setDescendent(true);
        }
    }, [columnFilter, filterName]);

    return (
        <button type="button" onClick={() => changeOrder()} className="order-btn icon-small">
            <Image
                src="images/figma/icon/arrow.svg"
                className={`svg-icon${ascendent ? " ascendent" : " descendent"}`}
            />
        </button>
    );
}
